import styled from "styled-components";
import IcoChecked from "../styles/images/ico_checkbox_checked.svg";
import IcoUnchecked from "../styles/images/ico_checkbox.svg";

export const FlexBox = styled.div`
  display: flex;
  align-items: center;
`;

export const Container = styled.div`
  width: 100%;
  /* max-width: 37.5rem; */
  margin: 0 auto;
`;

export const Section = styled.section`
  padding-top: 5rem;
  display: flex;
  min-height: calc(100vh - 6.8rem);
  flex-direction: column;
  justify-content: space-between;
  &.minPaddingTop {
    padding-top: 3.2rem;
  }
  &.nonePaddingTop {
    padding-top: 0;
  }
  .col {
    color: ${({ theme }) => theme.color.purple_secondary};
  }
  .pink {
    color: ${({ theme }) => theme.color.pink};
  }
`;
export const Content = styled.div`
  padding: 0 2.6rem;
`;

export const TextDiv = styled.div`
  text-align: center;
  h3 {
    font-size: 1.6rem;
    line-height: 2rem;
    font-family: NanumSquareB;
  }

  p {
    font-size: 1.4rem;
    line-height: 1.8rem;
    span {
      font-weight: 800;
    }
  }
`;
export const ImgWrap = styled.div`
  text-align: center;
  img {
    width: ${(props) => props.imgwidth}rem;
    margin-top: ${(props) => props.margintop}rem;
  }
`;
export const ButtonXXS = styled.button`
  background-color: ${(props) => props.col};
  background-color: ${({ theme }) => theme.color.purple_light};
  color: ${({ theme }) => theme.color.white};
  width: 6rem;
  height: 3.6rem;
  border-radius: 1rem;
  font-family: NanumSquareB;
  font-size: 1.4rem;
  line-height: 1.4rem;
  &:disabled {
    background-color: ${({ theme }) => theme.color.btn_disabled};
  }
`;
export const ButtonXS = styled.button`
  background-color: ${(props) => props.theme.color[props.col]};
  color: ${({ theme }) => theme.color.white};
  width: 12rem;
  height: 3.6rem;
  border-radius: 1rem;
  font-family: NanumSquareB;
  font-size: 1.4rem;
  line-height: 1.4rem;
  &:disabled {
    background-color: ${({ theme }) => theme.color.btn_disabled};
  }
`;

export const ButtonS = styled(ButtonXS)`
  background-color: ${(props) => props.theme.color[props.col]};
  height: 4.8rem;
  border-radius: 2.4rem;
  font-size: 1.8rem;
  line-height: 2.2rem;
`;

export const Button = styled(ButtonXS)`
  background-color: ${({ theme }) => theme.color.purple_dark};
  width: 16.3rem;
  height: 6rem;
  border-radius: 3rem;
  font-size: 1.8rem;
  line-height: 1.8rem;
`;

export const ButtonM = styled(ButtonXS)`
  background-color: ${({ theme }) => theme.color.purple_secondary};
  width: 20.7rem;
  height: 6rem;
  font-size: 1.6rem;
  line-height: 1.6rem;
  flex-shrink: 0;
  border-radius: 3rem;
`;

export const ButtonL = styled(Button)`
  width: 34.3rem;
  width: 100%;
  :disabled {
    background-color: #c1c0c6;
  }
`;

// Container Styles
export const ContainerHeader = styled.div`
  padding: 0 3rem;
  height: 6.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerSmall = styled.div`
  padding: 0;
  width: 90%;
  max-width: 80rem;
  margin: 0 auto;
`;

// Text Styles
export const SubTitle = styled.p`
  span {
    font-weight: 800;
  }
`;

// Input Styles
export const Inputs = styled.div`
  input {
    display: block;
    height: 4rem;

    :disabled {
    }
  }
`;

export const Btns = styled.div`
  padding: 1.6rem;
  button {
  }
`;
export const TwoBtns = styled.div`
  padding: 1.6rem;
  display: flex;
  justify-content: space-between;
  button {
    width: calc(50% - 0.9rem);
  }
`;

export const InputsDiv = styled.div`
  & > div {
    margin-top: 5rem;
  }
  & > div:nth-of-type(1) {
    margin-top: 0;
  }
  h3 {
    font-size: 1.6rem;
    font-style: normal;
    line-height: 2rem; /* 125% */
    margin-bottom: 0.5rem;
  }
  input {
    background-color: transparent;
    width: 100%;
    height: 3.4rem;
    line-height: 3.4rem;
    border-bottom: 1px solid #000;
    color: ${({ theme }) => theme.color.black};
    font-family: NanumSquareR;
    font-size: 1.6rem;

    ::placeholder {
      color: ${({ theme }) => theme.color.input_text_gray};
      font-family: NanumSquareR;
      font-size: 1.6rem;
      font-style: normal;
      line-height: 1.6rem;
    }
    -webkit-appearance: none;
    -webkit-border-radius: 0;
  }
  input:focus {
    outline: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-text-fill-color: ${({ theme }) => theme.color.black};
    -webkit-box-shadow: 0 0 0px 1000px #f8f7ff inset;
    box-shadow: 0 0 0px 1000px #f8f7ff inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  input:autofill,
  input:autofill:hover,
  input:autofill:focus,
  input:autofill:active {
    -webkit-text-fill-color: ${({ theme }) => theme.color.black};
    -webkit-box-shadow: 0 0 0px 1000px #f8f7ff inset;
    box-shadow: 0 0 0px 1000px #f8f7ff inset;
    transition: background-color 5000s ease-in-out 0s;
  }
  input:-internal-autofill-selected {
    background-color: transparent !important;
  }
`;
export const CheckBoxWrap = styled.div`
  display: flex;
  align-items: center;
  input[type="checkbox"] {
    display: none;
  }
  input[type="checkbox"] + label {
    display: flex;
    align-items: center;
  }
  input[type="checkbox"] + label::before {
    display: block;
    content: "";
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 1rem;
    background: url(${IcoUnchecked}) center center/cover no-repeat;
  }
  input[type="checkbox"]:checked + label::before {
    display: block;
    width: 1.8rem;
    height: 1.8rem;
    background: url(${IcoChecked}) center center/cover no-repeat;
  }
`;
export const BigCheckBoxWrap = styled.div`
  display: flex;
  align-items: center;
  input[type="checkbox"] {
    display: none;
  }
  input[type="checkbox"] + label {
    display: flex;
    align-items: center;
  }
  input[type="checkbox"] + label::before {
    display: block;
    content: "";
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 1rem;
    background: url(${IcoUnchecked}) center center/cover no-repeat;
  }
  input[type="checkbox"]:checked + label::before {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    background: url(${IcoChecked}) center center/cover no-repeat;
  }
`;

// tab menu
export const TabMenu = styled.ul`
  display: flex;
  margin-top: 2.2rem;
  li {
    font-weight: 700;
    width: 50%;
    height: 3.6rem;
    line-height: 3.6rem;
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme.color.black};
  }
  .focused {
    border-bottom: 3px solid ${({ theme }) => theme.color.purple_light};
    color: ${({ theme }) => theme.color.purple_primary};
    font-weight: 700;
  }
`;
